import gql from 'graphql-tag';

export const WATCHLIST_QUERY = gql`
    query Watchlist($tickers: [String!]!) {
        mutualFunds(tickers: $tickers) {
            iClass
            ticker
            trpCode
            moneyMarketType
            name: shortName
            shortName
            price {
                asOfDate
                price
                priceChange
                pricePercentChange
            }
            twelveMonthHighPrice {
                price
            }
            twelveMonthLowPrice {
                price
            }
            openToNewInvestors
            openToSubsequentInvestments
            selectFund
            inceptionDate
        }
    }
`;
